import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { VoucherForCampaignDefault_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	campaignID: string;
};

export const useCampaignEditQuery = ({ hotelID, campaignID }: Props) => {
	const { data } = useCustomSuspenseQuery(VoucherForCampaignDefault_EditPage_Query, {
		variables: { hotelID, voucherID: campaignID },
	});

	return data;
};
